// Status types
export const STATUS_TYPES = {
    DRAFT: 'DRAFT',
    SUBMITTED: 'SUBMITTED',
    WAITING_FOR_SUPPORT: 'WAITING_FOR_SUPPORT',
    SUPPORT_PROVIDED: 'SUPPORT_PROVIDED',
    UNDER_REVIEW: 'UNDER_REVIEW',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
    REVISION_REQUIRED: 'REVISION_REQUIRED',
    PENDING_LOCAL_RISK_ASSESSMENT: 'PENDING_LOCAL_RISK_ASSESSMENT',
};

// Labels
export const LABELS = {
    PLAN_STATUS: 'Plan Status',
    PLAN_STATUS_FIELD: 'Plan Status:',
    APPROVAL_FIELD: 'Approval:',
    TIMELINE_INFO: 'Timeline Information',
    CREATED: 'Created:',
    LAST_UPDATED: 'Last Updated:',
    APPROVAL_DATE: 'Approval Date:',
    APPROVAL_DETAILS: 'Approval Details',
    APPROVAL_COMMENT: 'Approval Comment:',
    NOT_SPECIFIED: 'Not Specified',
    NO_COMMENT: 'No approval comment provided.',
    CLOSE: 'Close',
    EXPAND_COMMENT: 'Expand approval comment',
    LOCAL_RISK_ASSESSMENT: 'Local Regulatory Risk Assessment',
    ASSESSED_BY: 'Assessed by'
};

// Status labels
export const STATUS_LABELS = {
    [STATUS_TYPES.DRAFT]: 'Draft',
    [STATUS_TYPES.SUBMITTED]: 'Submitted',
    [STATUS_TYPES.WAITING_FOR_SUPPORT]: 'Waiting for Support',
    [STATUS_TYPES.SUPPORT_PROVIDED]: 'Support Provided',
    [STATUS_TYPES.UNDER_REVIEW]: 'Under Review',
    [STATUS_TYPES.APPROVED]: 'Approved',
    [STATUS_TYPES.REJECTED]: 'Rejected',
    [STATUS_TYPES.REVISION_REQUIRED]: 'Revision Required',
    [STATUS_TYPES.PENDING_LOCAL_RISK_ASSESSMENT]: 'Pending Local Risk Assessment',
    UNKNOWN: 'Unknown'
};

// Approval status labels
export const APPROVAL_LABELS = {
    APPROVED: 'Approved',
    NOT_APPROVED: 'Not Approved',
    PENDING: 'Pending'
};

// Alert messages
export const ALERT_MESSAGES = {
    APPROVED: {
        title: 'Plan Approved',
        content: 'Your exit plan has been approved.'
    },
    UNDER_REVIEW: {
        title: 'Under Review',
        content: 'Your exit plan is currently being reviewed by the requested support teams.'
    },
    REJECTED: {
        title: 'Plan Requires Revision',
        content: 'Your exit plan has been reviewed and needs modification. Please check the approval comment.'
    },
    REVISION_REQUIRED: {
        title: 'Revision Required',
        content: 'Your exit plan requires revision. Please check the approval comment.'
    },
    PENDING_LOCAL_RISK_ASSESSMENT: {
        title: 'Waiting for the Regulatory Owner',
        content: 'The regulatory owner of the exit request must add the Local Regulatory Risk Assessment before this exemption request goes to the approving managers.'
    },
    SUBMITTED_FINAL: {
        title: 'Exit Plan Submitted',
        content: 'Exit plans are knowledge only and do not require approval. This plan is final.'
    }
};

// Icon sizes
export const ICON_SIZES = {
    TIMELINE: '1.2rem',
    PERSON: '1.1rem',
    CHIP: '0.75rem'
};